import {
  ExpenseDeclaration,
  PaginatedListResponse,
  APIErrorResponse,
  SearchRequestParams,
} from '@/types'
import { UseQueryResult } from '@tanstack/react-query'
import { useQueryList } from '../useQueryList'
import { QUERY_KEYS } from '@/constants'

export type ExpensesSearchParams = SearchRequestParams & {
  id?: string
  month?: number | number[]
  researcher?: string | string[]
  approved_by?: string | string[]
  reimbursement_type?: string
  status?: string | string[]
  startDate?: string
  endDate?: string
}

export const getUseExpensesKey = (): string[] =>
  QUERY_KEYS.EXPENSES.slice(0, 2) as string[]

export const useExpenses = (
  { ...params }: ExpensesSearchParams,
  enabled = true
): UseQueryResult<
  PaginatedListResponse<ExpenseDeclaration>,
  APIErrorResponse
> =>
  useQueryList({
    url: '/hours_reporting/hr/expenses/',
    options: {
      enabled,
    },
    params: {
      ...(!!params.id && {
        id: params.id,
      }),
      ...(!!params.researcher && {
        researcher: params.researcher,
      }),
      ...(!!params.approved_by && {
        approved_by: params.approved_by,
      }),
      ...(!!params.reimbursement_type && {
        reimbursement_type: params.reimbursement_type,
      }),
      ...(!!params.status && {
        status: params.status,
      }),
      ...(!!params.startDate && { date_start: params.startDate }),
      ...(!!params.endDate && { date_end: params.endDate }),
      limit: params.limit,
      offset: params.offset,
    },
  })
